import { chevron, chevronOpen } from './chevron-arrow.css';

export const ChevronArrow = ({ isOpen }: { isOpen?: boolean }) => (
  <svg
    className={`${chevron} ${isOpen ? chevronOpen : ''}`}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <polyline points="6 9 12 15 18 9"></polyline>
  </svg>
);
